import React, { useState } from 'react';

const TeamTable = ({ members, onEdit, onRemove }) => {
  const [sortField, setSortField] = useState('name');
  const [sortDirection, setSortDirection] = useState('asc');
  
  // Ordenar membros
  const sortedMembers = [...members].sort((a, b) => {
    // Verificar se estamos lidando com números, datas ou textos
    const aValue = typeof a[sortField] === 'string' && !isNaN(Date.parse(a[sortField])) 
      ? new Date(a[sortField]).getTime() // É uma data
      : typeof a[sortField] === 'string' && !isNaN(parseFloat(a[sortField]))
        ? parseFloat(a[sortField]) // É um número em string
        : a[sortField]; // Outro tipo de valor
      
    const bValue = typeof b[sortField] === 'string' && !isNaN(Date.parse(b[sortField])) 
      ? new Date(b[sortField]).getTime() // É uma data
      : typeof b[sortField] === 'string' && !isNaN(parseFloat(b[sortField]))
        ? parseFloat(b[sortField]) // É um número em string
        : b[sortField]; // Outro tipo de valor
    
    if (sortDirection === 'asc') {
      return aValue > bValue ? 1 : -1;
    } else {
      return aValue < bValue ? 1 : -1;
    }
  });
  
  // Alternar ordenação ao clicar no cabeçalho da coluna
  const handleSort = (field) => {
    if (field === sortField) {
      // Se já estamos ordenando por este campo, alternar direção
      setSortDirection(sortDirection === 'asc' ? 'desc' : 'asc');
    } else {
      // Novo campo, definir como padrão asc para nomes e desc para datas
      setSortField(field);
      setSortDirection(field === 'startDate' ? 'desc' : 'asc');
    }
  };
  
  // Formatar a data para exibição
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('pt-BR');
  };
  
  // Calcular tempo na empresa
  const calculateTimeInCompany = (startDate) => {
    const start = new Date(startDate);
    const today = new Date();
    
    // Calcular diferença em meses
    const months = (today.getFullYear() - start.getFullYear()) * 12 + 
      (today.getMonth() - start.getMonth());
    
    // Formatar a saída
    if (months < 1) {
      return "Menos de 1 mês";
    } else if (months === 1) {
      return "1 mês";
    } else if (months < 12) {
      return `${months} meses`;
    } else if (months === 12) {
      return "1 ano";
    } else {
      const years = Math.floor(months / 12);
      const remainingMonths = months % 12;
      
      if (remainingMonths === 0) {
        return `${years} ${years === 1 ? 'ano' : 'anos'}`;
      } else {
        return `${years} ${years === 1 ? 'ano' : 'anos'} e ${remainingMonths} ${remainingMonths === 1 ? 'mês' : 'meses'}`;
      }
    }
  };
  
  return (
    <div className="team-table-container">
      {members.length === 0 ? (
        <p className="no-data">Nenhum colaborador registrado. Adicione seu primeiro colaborador acima!</p>
      ) : (
        <table className="team-table">
          <thead>
            <tr>
              <th onClick={() => handleSort('name')}>
                Nome {sortField === 'name' && (sortDirection === 'asc' ? '▲' : '▼')}
              </th>
              <th onClick={() => handleSort('startDate')}>
                Data de Início {sortField === 'startDate' && (sortDirection === 'asc' ? '▲' : '▼')}
              </th>
              <th onClick={() => handleSort('salary')}>
                Salário {sortField === 'salary' && (sortDirection === 'asc' ? '▲' : '▼')}
              </th>
              <th onClick={() => handleSort('paymentDay')}>
                Dia de Pagamento {sortField === 'paymentDay' && (sortDirection === 'asc' ? '▲' : '▼')}
              </th>
              <th onClick={() => handleSort('bonusPercentage')}>
                Bônus (%) {sortField === 'bonusPercentage' && (sortDirection === 'asc' ? '▲' : '▼')}
              </th>
              <th>Tempo na Empresa</th>
              <th>Ações</th>
            </tr>
          </thead>
          <tbody>
            {sortedMembers.map(member => (
              <tr key={member.id}>
                <td>{member.name}</td>
                <td>{formatDate(member.startDate)}</td>
                <td>R$ {parseFloat(member.salary).toFixed(2)}</td>
                <td>Todo dia {member.paymentDay}</td>
                <td>{member.bonusPercentage}%</td>
                <td>{calculateTimeInCompany(member.startDate)}</td>
                <td className="action-buttons">
                  <button 
                    className="btn-edit" 
                    onClick={() => onEdit(member)}
                    title="Editar"
                  >
                    ✏️
                  </button>
                  <button 
                    className="btn-delete" 
                    onClick={() => {
                      if (window.confirm('Tem certeza que deseja remover este colaborador?')) {
                        onRemove(member.id);
                      }
                    }}
                    title="Remover"
                  >
                    🗑️
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
          <tfoot>
            <tr>
              <td><strong>TOTAL</strong></td>
              <td><strong>{members.length} colaborador(es)</strong></td>
              <td>
                <strong>
                  R$ {members.reduce((sum, member) => sum + parseFloat(member.salary || 0), 0).toFixed(2)}
                </strong>
              </td>
              <td colSpan="4"></td>
            </tr>
          </tfoot>
        </table>
      )}
    </div>
  );
};

export default TeamTable;